import type { RouteLocationNormalizedLoaded } from "vue-router";
import type { NavigateToRoute } from "@/utils/router/src/types";

//* 获取路由名称
export const useLocaleRoute = (route: RouteLocationNormalizedLoaded, locale: string): string | NavigateToRoute => {
    //* vue插件
    const router = useRouter();

    //* 数据初始化
    const name = route.meta?.route?.toString() || route.name?.toString() || "";
    const result = { name: name, query: route.query, params: route.params };

    //* 检测是否存在对应的语言路由
    if (router.hasRoute(`${name}_${locale}`)) {
        result.name = `${name}_${locale}`;
    }

    return result;
};
